export default __webpack_public_path__ + "static/media/Icon-Dropdown-Triangle.a8807a37.svg";